import React from 'react';

type HeaderProps = {
  heading: string;
};

const Header = ({ heading }: HeaderProps) => {
  return <h2 className="font-semibold text-xl">{heading}</h2>;
};

export default Header;
